<template>
  <!-- Authors Table Card -->
  <a-card :bordered="false" class="header-solid h-full">
    <a-row :gutter="24" type="flex">
      <!-- Authors Table Column -->
      <a-col :span="24" class="mb-24">
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="ml-20">
          <a-form-item label="活动标题">
            <a-input v-model="dataForm.activity_title" placeholder="活动标题" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="addOrUpdateHandle()">新增活动</a-button>
          </a-form-item>
        </a-form>

        <a-table :scroll="{ x: 2050 }" :columns="columns" :data-source="dataList" :pagination="false" rowKey="activity_id"
          :loading="dataListLoading">
          <template slot="quantity_switch" slot-scope="text">
            <a-tag :color="text === '1' ? 'green' : 'red'">{{ text === '1' ? '开启' : '关闭' }}</a-tag>
          </template>
          <template slot="model" slot-scope="text">
            <a-tag>{{ text === '1' ? '每天' : '活动整个周期' }}</a-tag>
          </template>
          <template slot="model_same" slot-scope="text">
            <a-tag :color="text === '1' ? 'green' : 'red'">{{ text === '1' ? '能重复' : '不能重复' }}</a-tag>
          </template>
          <template slot="is_show" slot-scope="text">
            <a-tag :color="text === '1' ? 'green' : 'red'">{{ text === '1' ? '上架' : '下架' }}</a-tag>
          </template>
          <template slot="participant_count" slot-scope="text">
            <span>{{ text || 0 }}</span>
          </template>
          <template slot="editBtn" slot-scope="text, row">
            <a-button type="link" class="btn-edit" @click="showParticipants(row)">
              参与详情
            </a-button>
            <a-button type="link" class="btn-edit" @click="addOrUpdateHandle(row.activity_id)">
              编辑
            </a-button>
            <a-button type="link" class="btn-edit" @click="deleteHandle(row.activity_id)">
              删除
            </a-button>
          </template>
        </a-table>
      </a-col>
      <!-- / Authors Table Column -->
    </a-row>

    <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
      :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" />
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";
export default {
  mixins: [viewModule],
  components: {
    addorupdate,
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/admin/activity/page",
        deleteURL: "/admin/activity/delete",
      },
      dataForm: {
        activity_title: "",
      },
      columns: [
        {
          title: "活动标题",
          dataIndex: "activity_title",
          width: 200,
          ellipsis: true
        },
        {
          title: "活动副标题",
          dataIndex: "activity_subtitle",
          width: 200,
          //超出显示省略号
          ellipsis: true
        },
        {
          title: "开始时间",
          dataIndex: "activity_start",
          width: 180
        },
        {
          title: "结束时间",
          dataIndex: "activity_end",
          width: 180
        },
        {
          title: "参与人数",
          dataIndex: "participant_count",
          width: 120,
          scopedSlots: { customRender: 'participant_count' }
        },
        {
          title: "人数上限",
          dataIndex: "quantity",
          width: 100
        },
        {
          title: "人数开关",
          dataIndex: "quantity_switch",
          scopedSlots: { customRender: "quantity_switch" },
          width: 100
        },
        {
          title: "投票模式",
          dataIndex: "model",
          scopedSlots: { customRender: "model" },
          width: 120
        },
        {
          title: "可投数量",
          dataIndex: "model_num",
          width: 100
        },
        {
          title: "重复投同一人",
          dataIndex: "model_same",
          scopedSlots: { customRender: "model_same" },
          width: 140
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          width: 180
        },
        {
          title: "是否上架",
          dataIndex: "is_show",
          scopedSlots: { customRender: "is_show" },
          width: 100,
          fixed: 'right'
        },
        {
          title: "操作",
          scopedSlots: { customRender: "editBtn" },
          width: 250,
          fixed: "right",
        },
      ],
    };
  },
  methods: {
    showParticipants(row) {
      this.$router.push({
        path: '/participants',
        query: {
          activity_id: row.activity_id,
          activity_title: row.activity_title,
        },
      });
    },
    // 重写删除方法，使用 activity_id 作为参数
    deleteHandle(id) {
      this.$confirm({
        title: this.mixinViewModuleOptions.deleteTitle || '是否删除当前选择数据',
        content: this.mixinViewModuleOptions.deleteContent || '删除后不可恢复,请谨慎操作',
        okText: this.mixinViewModuleOptions.deleteOkText || '确认删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          this.$http({
            url: "/admin/activity/delete",
            method: "post",
            data: {
              activity_id: id
            }
          }).then((res) => {
            if (res.code === 1) {
              this.$message.success('删除成功');
              this.getDataList();
            } else {
              this.$message.error(res.message || '删除失败');
            }
          }).catch(() => {
            this.$message.error('删除失败');
          });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
  },
};
</script>

